import styled from "styled-components";

export const StyledLoading = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;
